export function snack({ snack: { snack } }) {
  return snack;
}

export function logs({ logs: { logs } }) {
  return logs;
}

export function payloadLogs({ logs: { payload } }) {
  return payload;
}

export function users({ users: { users } }) {
  return users;
}

export function userMessages({ users: { messages } }) {
  return messages;
}

export function respuestas({ respuestas: { respuestas } }) {
  return respuestas;
}

export function masivos({ masivos: { masivos } }) {
  return masivos;
}

export function profile({ users: { profile } }) {
  return profile;
}

export function tenantUsers({ tenantUsers: { tenantUsers } }) {
  return tenantUsers;
}

export function loading({ tenantUsers: { loading } }) {
  return loading;
}

export function errorMessage({ tenantUsers: { errorMessage } }) {
  return errorMessage;
}

export function getRole({ users: { roles } }) {
  return roles;
}

export function isLoadingRoles({ users: { loading_roles } }) {
  return loading_roles;
}

export function isLoadingProfile({ users: { loading_profile } }) {
  return loading_profile;
}

export function isAuthenticated({ users: { isAuthenticated } }) {
  return isAuthenticated;
}

export function templates({ templates: { templates } }) {
  return templates;
}

export function sucursal_id({ users: { sucursal_id } }) {
  return sucursal_id;
}

export function number_of_unread_messages({
  users: { number_of_unread_messages },
}) {
  return number_of_unread_messages;
}

export function summary({ faqDashboard: { summary } }) {
  return summary;
}

export function daysFilter({ faqDashboard: { daysFilter } }) {
  return daysFilter;
}

export function isLoading({
  users: { loading: usersLoading },
  logs: { loading: logsLoading },
  respuestas: { loading: respuestasLoading },
  masivos: { loading: masivosLoading },
  templates: { loading: templatesLoading },
}) {
  return (
    usersLoading ||
    logsLoading ||
    respuestasLoading ||
    masivosLoading ||
    templatesLoading
  );
}

export function conversation({ users: { conversation } }) {
  return conversation;
}

export function faqDashboardLoading({ faqDashboard: { loading } }) {
  return loading;
}

export function surveys({ surveys: { surveys } }) {
  return surveys;
}

export function surveysLoading({ surveys: { loading } }) {
  return loading;
}

export function surveysCreating({ surveys: { creating } }) {
  return creating;
}

export function surveysUpdating({ surveys: { updating } }) {
  return updating;
}

export function surveysDeleting({ surveys: { deleting } }) {
  return deleting;
}

export function surveysToggling({ surveys: { toggling } }) {
  return toggling;
}

export function surveysErrorMessage({ surveys: { errorMessage } }) {
  return errorMessage;
}

export function surveyResponses({ surveys: { responses } }) {
  return responses;
}

export function surveyResponsesLoading({ surveys: { responsesLoading } }) {
  return responsesLoading;
}

export function surveyResponsesErrorMessage({ surveys: { responsesErrorMessage } }) {
  return responsesErrorMessage;
}